import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IEpisode } from "@project/models/episodes/episode";
import { Router } from "@angular/router";
import { AppStorage } from "@bbwt/utils/app-storage";
import { WalkIn } from "@project/walk-ins/classes/walk-in";

export enum NavigateOnView  {
    ViewEpisode,
    AddNote
}

@Component({
    selector: "duplicate-episodes-dialog",
    templateUrl: "./duplicate-episode-dialog.component.html",
    styleUrls: ["./duplicate-episode-dialog.component.scss"]
})
export class DuplicateEpisodesDialogComponent {
    private _visible = false;

    selectedEpisodeId: string;

    @Input() get visible() {
        return this._visible;
    }
    set visible(visible: boolean) {
        this._visible = visible;
        this.visibleChange.emit(visible);
    }
    @Output() readonly visibleChange = new EventEmitter<boolean>();

    @Input() duplicateEpisodes: IEpisode[] = [];
    @Input() duplicateBodyPartSide: IEpisode[] = [];
    @Input() tempEpisodeDupCheak: IEpisode = null;
    @Input() tempWalkIn: WalkIn | any = null;
    @Input() isWalkInDraft: boolean = false;
    @Input() selectedWalkInDate: Date = null;
    @Input() navigateBackOnDuplicateEditCancel: boolean = true;
    @Input() modal = false;
    @Input() closable = false;
    @Input() draggable = false;

    @Input() isPrescription: boolean = false;
    @Input() isForm: boolean = false;

    @Input() navigateOnView = NavigateOnView.ViewEpisode;

    @Output() readonly onHide = new EventEmitter<any>();
    @Output() readonly viewEpisode = new EventEmitter<string>();
    @Output() readonly createEpisode = new EventEmitter<void>();
    @Output() readonly selectExistingEpisode = new EventEmitter<string>();

    constructor(private router: Router) {}

    emitViewEpisode(episodeId: string) {
        this.visible = false;

        this.viewEpisode.emit(episodeId);

        if (this.tempEpisodeDupCheak) {
            var url = this.router.url.split("?");
            var onlyUrl = url[0];
            AppStorage.setItemForSession("tempEpisodeDupCheak", this.tempEpisodeDupCheak);
            AppStorage.setItemForSession("tempWalkIn", this.tempWalkIn);
            AppStorage.setItemForSession("backUrl", onlyUrl);
            AppStorage.setItemForSession("selectedWalkInDate", this.selectedWalkInDate);

            this.navigateOnViewEpisode(episodeId);
        }
        this.viewEpisode.emit(episodeId);
    }

    closeDialog() {
        this.visible = false;
        AppStorage.setItemForSession("tempEpisodeDupCheak", null);
        AppStorage.setItemForSession("tempWalkIn", null);
        AppStorage.setItemForSession("backUrl", null);
        AppStorage.setItemForSession("selectedWalkInDate", null);
    }

    emitCreateEpisode() {
        AppStorage.setItemForSession("tempEpisodeDupCheak", null);
        AppStorage.setItemForSession("tempWalkIn", null);
        AppStorage.setItemForSession("backUrl", null);
        AppStorage.setItemForSession("selectedWalkInDate", null);
        this.createEpisode.emit();
        this.visible = false;
    }

    emitSelectExistingEpisode() {
        this.selectExistingEpisode.emit(this.selectedEpisodeId);
        this.visible = false;
    }

    navigateOnViewEpisode(episodeId: string) {
        switch (this.navigateOnView) {
            case NavigateOnView.ViewEpisode:
                this.router.navigate([`/app/consultation-history/episode/view/${episodeId}`], {
                    queryParams: {
                        restoreDuplicateCheakState: this.navigateBackOnDuplicateEditCancel,
                        showPlusButton: false,
                        restoreWalkIn: !!this.tempWalkIn
                    }
                });
                break;
            case NavigateOnView.AddNote:
                this.router.navigate(["/app/notes/edit/0"], {
                    queryParams: {
                        episodeId: episodeId,
                        restoreDuplicateCheakState: this.navigateBackOnDuplicateEditCancel,
                        showPlusButton: false
                    }
                });
                break;
            default:
                this.router.navigate([`/app/consultation-history/episode/view/${episodeId}`], {
                    queryParams: {
                        restoreDuplicateCheakState: this.navigateBackOnDuplicateEditCancel,
                        showPlusButton: false,
                        restoreWalkIn: !!this.tempWalkIn
                    }
                });
        }
    }
}
